import React from "react";
import QrCode from "./Qrcode";


const PrinterData = () => {

    return (
        <div className="printer-box">
            <div className="qr-code-box">
                <QrCode showDetails={false} />
                <div className="button-box"><button>Print AP-QR <img src="img/printer.png" /> </button></div>
            </div>
            <div className="printer-screen">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th colSpan={4}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowSpan={5}></td>
                            <td colSpan={3} className="user-data">User_ID: HCADxxxx</td>

                        </tr>
                        <tr>
                            <td colSpan={4} className="user-data">Device_ID: HC3e3rdn374ry388jdfj3jf83ufr834fhu</td>
                        </tr>
                        <tr>
                            <td colSpan={4} className="user-data">Device_SN: 343jb4hgry4r32g43ybdhbd3y3ge3ybdy3gre</td>
                        </tr>
                        <tr>
                            <td colSpan={4} className="user-data">Datetime: 2025/01/22 13:23:21</td>
                        </tr>
                        <tr>
                            <td colSpan={4} className="user-data">Test Model: Regular </td>
                        </tr>
                        <tr>
                            <td >1</td>
                            <td className="title-box">CPU</td>
                            <td className="subtitle-box">
                                <div>RAM</div>
                                <hr />
                                <div>eMMC</div>
                            </td>
                            <td className="data-box">
                                <div>Used:<b> 1.7Gi</b><br />
                                    Free: <b>40Mi</b><br />
                                    Total: <b>1.8Gi</b></div>
                                <hr />
                                <div>Total: <b>29.1Gi</b></div>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td className="title-box">LAN</td>
                            <td className="subtitle-box">
                                <div>eth0</div>
                                <hr />
                                <div>eth1</div>
                                <hr />
                                <div>br0</div>
                            </td>
                            <td className="data-box">
                                <div>status: <b>UP</b><br />
                                    ip: <b>192.168.12.1</b><br />
                                    ping:<b> OK</b></div>
                                <hr />
                                <div>status: <b>UP</b><br />
                                    ip: <b>192.168.12.22</b><br />
                                    ping: <b>Ok</b></div>
                                <hr />
                                <div>status:<b> UP</b><br />
                                    ip: <b>192.168.12.1</b><br />
                                    ping: <b>OK</b></div>

                            </td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td className="title-box">WiFi</td>
                            <td className="subtitle-box">
                                <div>STA</div>
                                <hr />
                                <div>AP</div>

                            </td>
                            <td className="data-box">
                                <div>wlan0: <b>192.168.12.4</b><br />
                                    ssid: <b>OfficeAir-2</b><br />
                                    ping: <b>OK</b></div>
                                <hr />
                                <div>ssid: <b>SmartAI-G-WiFi</b><br />
                                    password: <b>2fx4rstsdt43d</b></div>

                            </td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td className="title-box">Peripherals</td>
                            <td className="subtitle-box">
                                <div>LED</div>
                                <hr />
                                <div className="small-box">RST</div>
                                <hr />
                                <div className="small-box">SPI</div><hr />
                                <div className="small-box">CT</div><hr />
                                <div className="small-box">RS-485
                                </div>

                            </td>
                            <td className="data-box">
                                <div>LED red blink: <b>OK</b><br />
                                    LED green blink: <b>OK</b><br />
                                    LED blue blink: <b>OK</b></div>
                                <hr />
                                <div className="small-box">RST button press check: <b>OK</b></div>
                                <hr />
                                <div className="small-box">SPI communication check: <b>OK</b>
                                </div>
                                <hr />
                                <div className="small-box">CT data/measurement check: <b>OK</b>
                                </div>
                                <hr />
                                <div className="small-box">RS-485 communication check: <b>OK</b>
                                </div>

                            </td>
                        </tr>

                    </tbody>
                </table>
                <div className="button-box"><button>Export CSV <img src="img/csv.png" /> </button></div>
            </div>

        </div>

    );
};

export default PrinterData;